const DispatchAdvice = {

    // FIELDS
    "sales_order": "طلب مبيعات",
    "dispatch": "إرسال",
    "pending": "قيد الانتظار",
    "item": "عنصر",
    "rate": "معدل",
    "quantity": "كمية",
    "unit": "وحدة",
    "sub_total": "المجموع الفرعي",
    "discount": "خصم",
    "vat": "ضريبة القيمة المضافة",
    "remark": "ملاحظة",
    "total": "المجموع",
    "search": "بحث",
    "delivery_date": "تاريخ التسليم",

    // BUTTON
    "confirm": "تأكيد",

    // PAGE HEADER
    "dipatch_advice": "نصيحة الإرسال",

    // TOOLTIP
    "approve": "موافقة",
    "reject": "رفض",

    // SWEET ALERT
    "approve_confirm_text": "هل أنت متأكد أنك تريد الموافقة على نصيحة الإرسال؟",
    "reject_confirm_text": "هل أنت متأكد أنك تريد رفض نصيحة الإرسال؟",
    "status": "الحالة",
    "status_text": "تم تغيير الحالة بنجاح",

    // ERROR
    "error_so": "حدد طلب المبيعات",
    "error_item": "حدد العنصر",
    "error_qty": "أدخل الكمية",
    "error_qty_positive": "الكمية يجب أن تكون إيجابية",
    "error_item_nf": "العنصر غير موجود",

    // TABLE HEADER
    "table_so_code": "كود طلب المبيعات",
    "table_da_code": "كود نصيحة الإرسال",
    "table_booking_date": 'تاريخ الحجز',
    "table_delivery_date": "تاريخ التسليم",
    "table_customer": "العميل",
    "table_status": "الحالة",
}

export default DispatchAdvice;